// FieldVision - KortHistorik.tsx
// Liste af kort-cards med accordion funktionalitet
// Kun et kort kan vaere aktivt (aabent) ad gangen
// NEW: Support for delete callback

import React from 'react';
import KortCard from './zones/KortCard';
import { ZoneData } from './zones/ZoneRow';

interface FieldMap {
  Id: number;
  FieldId: number | null;
  OrderId: number | null;
  Type: string;
  Source: string;
  CaptureDate: string;
  Status: string;
  ZonesJson?: string;
  Zones?: any;
  ThumbnailPath?: string;
  CreatedAt: string;
  Marknr: string;
  Areal: number | null;
  CVR: string;
}

interface KortHistorikProps {
  maps: FieldMap[];
  activeMapId: number | null;
  onMapSelect: (mapId: number) => void;
  onZonesChange?: (zones: ZoneData[]) => void;
  onMapDelete?: (mapId: number, deleteType: 'hard' | 'soft') => void;
}

const KortHistorik: React.FC<KortHistorikProps> = ({
  maps,
  activeMapId,
  onMapSelect,
  onZonesChange,
  onMapDelete
}) => {
  // Grupper kort efter type
  const mapsByType = maps.reduce((acc, map) => {
    const type = map.Type || 'other';
    if (!acc[type]) acc[type] = [];
    acc[type].push(map);
    return acc;
  }, {} as Record<string, FieldMap[]>);

  const getTypeLabel = (type: string) => {
    switch (type?.toLowerCase()) {
      case 'ndvi':
        return 'NDVI Kort';
      case 'ndre':
        return 'NDRE Kort';
      case 'weed':
        return 'Ukrudtskort';
      case 'regrowth':
        return 'Genvaekstkort';
      default:
        return type || 'Tildelingskort';
    }
  };

  return (
    <div className="kort-historik">
      {Object.entries(mapsByType).map(([type, typeMaps]) => (
        <div key={type} className="kort-type-section">
          {Object.keys(mapsByType).length > 1 && (
            <h4 className="kort-type-header">{getTypeLabel(type)}</h4>
          )}
          <div className="kort-cards-list">
            {typeMaps.map(map => (
              <KortCard
                key={map.Id}
                map={map}
                isActive={activeMapId === map.Id}
                onSelect={() => onMapSelect(map.Id)}
                onZonesChange={onZonesChange}
                onDelete={onMapDelete}
              />
            ))}
          </div>
        </div>
      ))}

      <style>{`
        .kort-historik {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .kort-type-section {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .kort-type-header {
          margin: 0;
          font-size: 12px;
          font-weight: 600;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .kort-cards-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
      `}</style>
    </div>
  );
};

export default KortHistorik;
